import { SVGProps } from 'react';

function PhoneMessage(
  props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>
) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.375 8.125V11.259C7.375 12.0134 6.76342 12.625 6.009 12.625H2.7415C1.987 12.625 1.37528 12.0135 1.375 11.259V3.4915C1.37528 2.73692 1.98692 2.12528 2.7415 2.125H4"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.375 10.375H7.375"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.125 1.375H7C6.17157 1.375 5.5 2.04657 5.5 2.875V5.125C5.5 5.95343 6.17157 6.625 7 6.625H8.875V8.5L10.75 6.625H11.125C11.9534 6.625 12.625 5.95343 12.625 5.125V2.875C12.625 2.04657 11.9534 1.375 11.125 1.375Z"
        stroke="currentcolor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.1875 3.8125C7.08395 3.8125 7 3.89645 7 4C7 4.10355 7.08395 4.1875 7.1875 4.1875C7.29105 4.1875 7.375 4.10355 7.375 4C7.375 3.89645 7.29105 3.8125 7.1875 3.8125"
        stroke="currentcolor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.0625 3.8125C8.95895 3.8125 8.875 3.89645 8.875 4C8.875 4.10355 8.95895 4.1875 9.0625 4.1875C9.16605 4.1875 9.25 4.10355 9.25 4C9.25 3.89645 9.16605 3.8125 9.0625 3.8125"
        stroke="currentcolor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.9375 3.8125C10.8339 3.8125 10.75 3.89645 10.75 4C10.75 4.10355 10.8339 4.1875 10.9375 4.1875C11.0411 4.1875 11.125 4.10355 11.125 4C11.125 3.89645 11.0411 3.8125 10.9375 3.8125"
        stroke="currentcolor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

PhoneMessage.defaultProps = {
  role: 'graphics-document',
};

export default PhoneMessage;
